/**
 * Valid field names for STD benefits
 *
 * Used to filter out extraneous fields when transforming to API format.
 * Includes both simple fields and nested object fields.
 */

export const STD_VALID_FIELDS = new Set([
  "objectType",
  "currentCarrierName",
  "eligibilityClasses",
  "benefitAmount",
  "maximumAmount",
  "definitionOfDisability",
  "definitionOfEarnings",
  "employerContribution",
  "eliminationPeriodAccident",
  "eliminationPeriodIllness",
  "benefitDuration",
  "preExistingCondition",
  "ficaMatch",
  "billableType",
  "extended",
]);
